import useGlobalToast from '@/composables/useGlobalToast';

interface ExtendedShareData extends ShareData {
    info: {
        summary: string;
        detail: string;
    };
}

export async function shareLink(data: ExtendedShareData): Promise<void> {
    const { defaultToastOptions, addToast } = useGlobalToast();
    const { info, ...shareData } = data;

    try {
        await navigator.share(shareData);
    } catch (error: unknown) {
        if (error instanceof DOMException && error.name === 'AbortError') {
            // User cancelled the share action, no need to show a toast
            return;
        }

        await navigator.clipboard.writeText(shareData.url ?? shareData.text ?? '');
        addToast({
            ...defaultToastOptions,
            summary: info.summary,
            detail: info.detail,
        });
    }
}
